import BopisBar from '@cat/bopis-bar';
import React, { useContext } from 'react';
import { BopisContext } from '@core-ui/bopis';
import { useClpState } from '../../providers/app-state-provider';
import LeftFacetedGridMediator from './mediator';

const BopisBarFragment = (position): JSX.Element => {
  const bopisData = useContext(BopisContext);
  const { brandInfo, datalayer, pageType, hideBopis } = useClpState();

  return (
    !hideBopis &&
    <div data-testid="bopis-bar">
      <BopisBar
        position={position}
        key="sticky-bopis-bar"
        abbrNameForTealium={brandInfo.abbrNameForTealium}
        bopisData={bopisData}
        businessUnitId={brandInfo.marketAwareBrandCode}
        datalayer={datalayer}
        pageType={pageType}
        mediator={LeftFacetedGridMediator}
        isBopisHidden={false}
      />
    </div>
  );
};

export default BopisBarFragment;
